module.exports = __webpack_public_path__ + "static/media/PopulationHealth.e2da5d48.svg";